import {
  IconButtonProps,
  IconButton,
  Menu,
  MenuItem,
  MenuProps,
  alpha,
  styled,
} from "@mui/material";
import { MouseEventHandler, ReactNode, useState } from "react";
import { IMenuOption } from "../../types/global";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 87,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

interface Props {
  icon: ReactNode;
  options: IMenuOption[];
  onSelect: MouseEventHandler;
  size?: IconButtonProps["size"];
  disabled?: IconButtonProps["disabled"];
  sx?: IconButtonProps["sx"];
}

const CustomizedIconMenuButton = ({
  icon,
  options,
  onSelect,
  size,
  disabled,
  sx,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton
        id="demo-customized-button"
        onClick={handleClick}
        size={size ? size : "small"}
        disabled={disabled}
        sx={sx}
      >
        {icon}
      </IconButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {options.map((option: IMenuOption, index: number) => (
          <MenuItem
            onClick={(e) => {
              onSelect(e);
              handleClose();
            }}
            disabled={option.disabled}
            disableRipple
            key={index}
          >
            {option.value}
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
};

export default CustomizedIconMenuButton;
